require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-should-your-employer-fund-your-education-heres-how-and-why-you-should-ask.json") })
        }
      }, "path---blog-should-your-employer-fund-your-education-heres-how-and-why-you-should-ask");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-should-your-employer-fund-your-education-heres-how-and-why-you-should-ask!./.cache/json/blog-should-your-employer-fund-your-education-heres-how-and-why-you-should-ask.json
// module id = 1023
// module chunks = 231608221292675